import { cloudsaveQueryApi } from 'api/cloudsave/cloudsaveQueryApi';
import { suggestionsQueryApi } from 'api/suggestions/suggestionsQueryApi';
import { combineReducers } from 'redux';
import { settingsReducer } from './settings/reducer';
import { contextMenuReducer } from './contextmenu/reducer';
import { unitInfoDataReducer } from './unitInfoData/reducer';
import { storageUnitsReducer } from './storageunits/reducer';
import { snackbarReducer } from './snackbar/reducer';
import { performanceguaranteeReducer } from './performanceGuarantee/reducer';
import { agreementReducer } from './agreement/reducer';
import { unitReducer, undoableActions } from './units/reducer';
import { createUndoableReducer } from './createHistoryReducer';
import { layoutReducer } from './layout/reducer';
import { documentMetadataReducer } from './documentMetadata/reducer';
import { fileStateReducer } from './fileState/reducer';
import { simulationReducer } from './simulation/reducer';
import { connectionReducer } from './connection/reducer';

export const rootReducer = combineReducers({
  [cloudsaveQueryApi.reducerPath]: cloudsaveQueryApi.reducer,
  [suggestionsQueryApi.reducerPath]: suggestionsQueryApi.reducer,
  unitConnGroup: createUndoableReducer(unitReducer, undoableActions),
  settingsState: settingsReducer,
  documentMetadata: documentMetadataReducer,
  fileState: fileStateReducer,
  simulationState: simulationReducer,
  unitInfoDataState: unitInfoDataReducer,
  contextMenuState: contextMenuReducer,
  storageUnitsState: storageUnitsReducer,
  snackbarReducer: snackbarReducer,
  pgState: performanceguaranteeReducer,
  agreement: agreementReducer,
  layout: layoutReducer,
  connectionState: connectionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
